<template>
  <WsStateDropdownCheckboxInputAvatar001
    v-model="state"
    required
    outline
    title="填表人員"
    leading-icon="icon-outline-perm-identity"
    rules="required"
    placeholder="填表人員填表人員"
  />
</template>

<script>
export default {
  data() {
    return {
      state: []
    }
  }
}
</script>